module.exports = __webpack_public_path__ + "img/ctht-poster.ca998cc1.jpg";